<template>
  <div>
    <el-card class="box-card">
      <!-- <div class="title mt20">视力</div> -->
      <el-table :data="dataList" border stripe class="mt15">
        <el-table-column prop="Righteyedegree" label="球镜OD(右眼)"></el-table-column>
        <el-table-column prop="Lefteyedegree" label="球镜OS(左眼)"></el-table-column>
        <el-table-column prop="Rightcolumnmirror" label="柱镜OD(右眼)"></el-table-column>
        <el-table-column prop="Leftcolumnmirror" label="柱镜OS(左眼)"></el-table-column>
        <el-table-column prop="Rightaxial" label="轴位OD(右眼)"></el-table-column>
        <el-table-column prop="Leftaxial" label="轴位OS(左眼)"></el-table-column>
        <el-table-column prop="Nakedrighteyedegree" label="裸眼视力OD(右眼)"></el-table-column>
        <el-table-column prop="Nakedlefteyedegree" label="裸眼视力OS(左眼)"></el-table-column>
        <el-table-column prop="Nakedbinoculusdegree" label="裸眼视力OU(双眼)"></el-table-column>
        <el-table-column prop="Correctrighteyedegree" label="最佳矫正视力OD(右眼)"></el-table-column>
        <el-table-column prop="Correctlefteyedegree" label="最佳矫正视力OS(左眼)"></el-table-column>
        <el-table-column prop="Correctbinoculusdegree" label="最佳矫正视力OU(双眼)"></el-table-column>
        <el-table-column prop="Createtime" label="时间"></el-table-column>
      </el-table>
      <el-button type="info" class="mt20" @click="backDeviceManagement">返回</el-button>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      dataList: [],
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apiGetRuischoolscDushuList()
    },
    backDeviceManagement () {
      this.$emit('triggerFunc', '')
    },
    apiGetRuischoolscDushuList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        useruuid: that.parentdata.params.useruuid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRuischoolscDushuList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
            console.log(response.data)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
